const DEFAULT_COUNTRY = {
    name: 'United States',
    countryCode: 'us',
    dialCode: '1',
    format: '+. (...) ...-....',
};

const stripNonDigits = (value) => String(value || '').replace(/\D/g, '');

function getCountryName(country) {
    return country?.name || country?.countryCode?.toUpperCase() || 'selected country';
}

function getExpectedNationalLength(country) {
    const dialCode = stripNonDigits(country?.dialCode);
    const format = String(country?.format || '');
    if (!dialCode || !format) return null;

    const totalPlaceholders = (format.match(/\./g) || []).length;
    const nationalLength = totalPlaceholders - dialCode.length;
    return nationalLength >= 4 && nationalLength <= 14 ? nationalLength : null;
}

function getNationalDigits(value, country = DEFAULT_COUNTRY) {
    const digits = stripNonDigits(value);
    const dialCode = stripNonDigits(country?.dialCode);
    if (!digits || !dialCode) return '';
    return digits.startsWith(dialCode) ? digits.slice(dialCode.length) : digits;
}

export function normalizePhoneForOtp(value, country = DEFAULT_COUNTRY) {
    const digits = stripNonDigits(value);
    const dialCode = stripNonDigits(country?.dialCode);
    if (!digits || !dialCode) return digits;
    return digits.startsWith(dialCode) ? digits : `${dialCode}${digits}`;
}

export function getPhoneValidationError(value, country = DEFAULT_COUNTRY) {
    const dialCode = stripNonDigits(country?.dialCode);
    const nationalDigits = getNationalDigits(value, country);
    const fullDigits = normalizePhoneForOtp(value, country);
    const countryName = getCountryName(country);

    if (!fullDigits) return 'Please enter a phone number.';
    if (!dialCode) return 'Please select a country code.';
    if (!nationalDigits) return `Enter the phone number after +${dialCode}.`;
    if (fullDigits.length < 8 || fullDigits.length > 15) {
        return 'Enter a valid phone number with country code.';
    }

    const expectedLength = getExpectedNationalLength(country);
    if (expectedLength && nationalDigits.length !== expectedLength) {
        return `Enter a valid ${countryName} phone number: ${expectedLength} digits after +${dialCode}.`;
    }

    return '';
}

export { DEFAULT_COUNTRY };
